import React from 'react';
import { Icon, Tooltip } from 'antd';

const Columns = (onDelete) => {
  return [
    {
      title: '',
      key: 'action',
      width: '5%',
      align: 'center',
      render: (text, record) => <Tooltip title="Xóa dòng này"><Icon className='gx-text-danger' onClick={() => onDelete(record.key)} type="delete" /></Tooltip>,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      editable: true,
      width: '30%',
    },
    {
      title: 'Phân quyền',
      dataIndex: 'role',
      editable: true,
      width: '30%',
    },
    {
      title: 'Line manager',
      dataIndex: 'line_manager',
      editable: true,
      width: '30%',
    },
  ];
};

export default Columns;
